(() => {
  const start = (root) => {
    if (root.dataset.supportReady) return;
    root.dataset.supportReady = 'true';
    const topic = root.querySelector('[data-support-topic]');
    const summary = root.querySelector('summary');
    const close = root.querySelector('[data-support-close]');
    const topics = root.querySelector('[data-support-topics]');
    const links = [...root.querySelectorAll('[data-support-country]')];
    if (topic && !root.dataset.productTitle) topic.value = 'other';
    const knownLinks = new Map([
      ['https://wa.link/6vsvp3', '601133338028'],
      ['https://wa.link/b5dlo4', '6598827200']
    ]);
    const updateLinks = () => {
      const selected = topic?.selectedOptions[0]?.textContent.trim() || '';
      const lines = [(root.dataset.message || '').replace('__OUSON_TOPIC__', () => selected)];
      if (root.dataset.productTitle && root.dataset.productUrl) {
        lines.push((root.dataset.productMessage || '').replace('__OUSON_PRODUCT__', () => root.dataset.productTitle));
        lines.push(root.dataset.productUrl);
      }
      for (const link of links) {
        try {
          const original = new URL(link.dataset.supportUrl);
          const phone = knownLinks.get(original.href.replace(/\/$/, '')) || (original.hostname === 'wa.me' ? original.pathname.slice(1).replace(/\/$/, '') : '');
          if (!/^\d{8,15}$/.test(phone) || original.protocol !== 'https:') continue;
          const url = new URL('https://wa.me/' + phone);
          url.searchParams.set('text', lines.filter(Boolean).join('\n'));
          link.href = url.href;
        } catch {}
      }
    };
    updateLinks();
    topics.hidden = false;
    close.hidden = false;
    topic?.addEventListener('change', updateLinks);
    const dismiss = (restoreFocus) => {
      if (!root.open) return;
      root.open = false;
      if (restoreFocus) summary.focus();
    };
    close.addEventListener('click', () => dismiss(true));
    root.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && root.open) {
        event.preventDefault();
        event.stopPropagation();
        dismiss(true);
      }
    });
    document.addEventListener('pointerdown', (event) => {
      if (root.isConnected && !root.contains(event.target)) dismiss(false);
    });
  };
  const init = (parent) => {
    if (parent.matches?.('[data-ouson-support]')) start(parent);
    parent.querySelectorAll?.('[data-ouson-support]').forEach(start);
  };
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
